module.exports = "/*\r\n*********************\r\n**    BOOTSTRAP    **\r\n*********************\r\n*/\n:root {\n  --navbar-toggle-border-color: darken(#a82339, 10%); }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/telefone-input/telefone-input.component.scss
// module id = ./src/app/common/telefone-input/telefone-input.component.scss
// module chunks = main